import { baseFetchToken } from './BaseSaga'
import PromoSectionActions from '../Redux/PromoSectionRedux'
import { getToken } from '../Services/GetToken'

export function * getPromoSection (api, action) {
  yield baseFetchToken(
    api.getPromoSection,
    action.data,
    getToken,
    PromoSectionActions.getPromoSectionSuccess,
    PromoSectionActions.getPromoSectionFailure
  )
}

export function * updatePromoSection (api, action) {
  yield baseFetchToken(
    api.updatePromoSection,
    action.data,
    getToken,
    PromoSectionActions.updatePromoSectionSuccess,
    PromoSectionActions.updatePromoSectionFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/PromoSectionSagas.js